import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  TeacherImageGalleryPage,
  TeacherLoadingState,
  TeacherPageShell,
  useTeacherAdventureOverview,
} from './teacherAdventureShared';

export const TeacherEscapeImagesPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const selectedDate = searchParams.get('date') ?? undefined;
  const selectedLessonRunId = searchParams.get('lessonRunId') ?? undefined;
  const { overview, isLoading, loadError, reloadOverview } = useTeacherAdventureOverview(
    selectedDate,
    selectedLessonRunId
  );
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await reloadOverview({ silent: true });
    } finally {
      setIsRefreshing(false);
    }
  };

  if (isLoading || loadError) {
    return (
      <TeacherPageShell title="展开逃生过程" description="这里查看学生上传的逃生过程图片。">
        <TeacherLoadingState error={loadError} loadingText="正在加载逃生过程图片..." />
      </TeacherPageShell>
    );
  }

  return (
    <TeacherImageGalleryPage
      title="展开逃生过程"
      description="这里查看学生上传的逃生过程图片。"
      imageLabel="逃生过程"
      records={overview.escapeImageRecords}
      emptyText="当前还没有学生上传逃生过程图片。"
      onRefresh={() => {
        void handleRefresh();
      }}
      isRefreshing={isRefreshing}
    />
  );
};
